<template>
  <div class="other-website-card">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />
    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />
    <div v-if="!loading">
      <div
        class="company-info d-flex animate-fadein"
        v-if="!loading && companyData && companyData.name"
      >
        <div class="linkedin-link-section">
          <div class="decision-link-head" v-if="companyData.name">
            {{ companyData.name }}
          </div>
          <div
            class="linkedInBtn flex-c"
            @click="openLinkedInPage"
            v-if="companyData.linkedInCompanyPageUrl"
          >
            <Linkedin-Logo-Icon viewBox="0 0 100 100" />
            <span>View on Linkedin</span>
          </div>
        </div>

        <div
          class="decision-link flex-c float-l width-100 txt-blue"
          v-if="companyData.primaryDomain && companyData.website"
        >
          <Decision-Link />
          <a :href="companyData.website" target="_blank" class="txt-blue">{{
            companyData.primaryDomain
          }}</a>
        </div>
        <div
          class="company-count flex-c float-l width-100"
          v-if="companyData.employeeCount"
        >
          <Company-Count />
          <span>{{ companyData.employeeCount }}</span>
        </div>
        <div
          class="revenue flex-c float-l width-100"
          v-if="companyData.revenue"
        >
          <Revenue />
          <span>{{ companyData.revenue }}</span>
        </div>
        <div
          class="industry flex-c float-l width-100"
          v-if="companyData.industry"
        >
          <Industry-Icon />
          <span>{{ companyData.industry }}</span>
        </div>
      </div>
      <div class="not-found-cinfo" v-else>
        <div class="img-center">
          <img src="./../../assets/images/company.png" />
        </div>
        <p>Sorry, We couldn't find the company information for {{ domain }}</p>
      </div>
    </div>
    <div class="placeholder bottom" v-else>
      <div class="company-info d-flex animate-fadein">
        <div class="decision-link-head linear-background"></div>
        <div class="decision-link flex-c float-l width-100 txt-blue">
          <Decision-Link />
          <a target="_blank" class="txt-blue linear-background"></a>
        </div>
        <div class="company-count flex-c float-l width-100">
          <Company-Count />
          <span class="linear-background"></span>
        </div>
        <div class="revenue flex-c float-l width-100">
          <Revenue />
          <span class="linear-background"></span>
        </div>
        <div class="industry flex-c float-l width-100">
          <Industry-Icon />
          <span class="linear-background"></span>
        </div>
      </div>
    </div>

    <div
      class="view-all txt-blue"
      v-if="totalContacts && companyData.primaryDomain"
      @click="showAllOtherContact"
      :data-link="companyData.primaryDomain"
    >
      View {{ totalContacts | formatNumber }}
      {{ totalContacts | singularPlural('contact') }} from
      {{ companyData.name }}
    </div>

    <div
      class="top-contact-section d-flex animate-fadein"
      v-if="contactsData && contactsData.length > 0"
    >
      <div class="top-contact-head" v-if="companyData.name">
        Top Contacts in {{ companyData.name }}
      </div>
      <ul>
        <li v-for="(ele, index) in contactsData" :key="index">
          <Website-Contact-Card :contactData="ele" :ind="index" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { post } from './../../assets/util/rest.js'
import {
  advanceSearchUrl,
  TRIGGERS_TRACK_TO_LB
} from './../../assets/util/constants/constants.js'
import sharedFunctions from './../../assets/util/functions.js'
import {
  MX_VIEW_ON_LINKEDIN_CLICKED,
  MX_VIEW_SIMILAR_CONTACTS_OTHER_DOMAIN
} from './../../assets/util/constants/analytics.js'

import decisionLinkIcon from './../../assets/icons/svg/grid-world-1.svg'
import companyCountIcon from './../../assets/icons/svg/group-2.svg'
import revenueIcon from './../../assets/icons/svg/coin-1.svg'
import industryIcon from './../../assets/icons/svg/factory.svg'
import linkedinLogoIcon from './../../assets/icons/svg/linkedin-logo-icon.svg'
import websiteContactCard from '@/components/otherWebsite/WebsiteContactCard.vue'
import UpgradePopup from '@/components/UpgradePopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'

export default {
  name: 'WebsiteCard',
  props: ['loading', 'companyData', 'contactsData', 'totalContacts', 'domain'],
  watch: {
    profileData: {
      handler(newValue, oldValue) {
        if (oldValue != newValue && newValue.email == null) {
          this.findEmail()
        }
      }
    }
  },
  data: function() {
    return {
      copyState: false,
      showPopup: false,
      showActivationPopup: false
    }
  },
  components: {
    'Decision-Link': decisionLinkIcon,
    'Company-Count': companyCountIcon,
    Revenue: revenueIcon,
    'Industry-Icon': industryIcon,
    'Website-Contact-Card': websiteContactCard,
    'Upgrade-Popup': UpgradePopup,
    'Linkedin-Logo-Icon': linkedinLogoIcon,
    'Activation-Popup': ActivationPopup
  },
  computed: {
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    }
  },
  methods: {
    updatePhoneAndEmail(res) {
      this.profileData.email = res.email
      this.profileData.phone = res.phone
      this.profileData.contactAlreadyOwned = true
    },
    findEmailWithCustomDomain(inputData) {
      this.profileData.domain = inputData.domain
      this.profileData.companyName = inputData.companyName
      this.findEmail(true)
    },
    doNothing() {},
    getLevelNameFromLevel(level) {
      let levelName = null
      if ('C-Level' === level || 'VP-Level' === level) {
        levelName = 'Decision maker'
      } else if ('Director-Level' === level) {
        levelName = 'Influencer'
      } else if ('Manager-Level' === level) {
        levelName = 'Champion'
      } else {
        levelName = level
      }
      return levelName
    },
    canShowButton() {
      return (
        this.profileData.domain &&
        (!this.profileData.email || this.profileData.email.indexOf('*') != -1)
      )
    },
    constructReqData(profile) {
      let reqData = {}
      reqData['linkedinId'] = profile['linkedinId']
      reqData['fullName'] = profile['fullName']
      reqData['address'] = profile['address']
      reqData['companyName'] = profile['companyName']
      reqData['title'] = profile['title']
      reqData['domain'] = profile['domain']
      return reqData
    },
    findEmail(autoTrigger) {
      if (this.profileData.domain) {
        const reqData = this.constructReqData(this.profileData)
        post('li/adv/profile.htm', reqData)
          .then(response => {
            if (response.status == 200) {
              response.json().then(res => {
                if (res) {
                  if (res && res.statusCode === '200') {
                    this.updatePhoneAndEmail(res.response)
                    if (autoTrigger) this.triggerFindEmail = true
                    //get email is automatically clicked
                  }
                }
              })
            }
          })
          .catch(e => {
            console.log('error: ' + e)
          })
      }
    },
    copyClipboard(e) {
      // document.getElementById("ID_personEmailValue").select();
      e.currentTarget.previousSibling.select()
      document.execCommand('copy')
      this.copyState = true
      let thisObj = this
      setTimeout(function() {
        thisObj.copyState = false
      }, 1000)
    },
    showAllOtherContact(e) {
      if (!this.isAccountVerified) {
        this.showActivationError()
      } else {
        const dataMap = { domain: this.domain }
        sharedFunctions.track(
          MX_VIEW_SIMILAR_CONTACTS_OTHER_DOMAIN,
          dataMap,
          this.$store.state
        )
        const that = this
        const target = e.currentTarget
        setTimeout(function() {
          let domain = target.getAttribute('data-link')
          if (domain != '')
            window.open(
              advanceSearchUrl(
                domain,
                that.$store.state.header.uiVersion,
                TRIGGERS_TRACK_TO_LB.WEBSITE_VIEW_CONTACTS
              )
            )
        }, 500)
      }
    },
    openLinkedInPage() {
      if (this.companyData && this.companyData.linkedInCompanyPageUrl)
        sharedFunctions.track(
          MX_VIEW_ON_LINKEDIN_CLICKED,
          null,
          this.$store.state
        )
      let url = this.companyData.linkedInCompanyPageUrl
      if (url.indexOf('http') == -1) url = `http://${url}`
      window.open(url)
    },
    showActivationError() {
      this.showActivationPopup = true
    }
  },
  created() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin lineClamp($line) {
  display: -webkit-box;
  -webkit-line-clamp: $line;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(59, 59, 59, 0.15);
  }
  li:last-child {
    border-bottom: none;
  }
}

.other-website-card {
  width: 100%;
  color: $grey-color;

  line-height: 22px;
  a {
    text-decoration: none;
  }

  .placeholder {
    .linear-background {
      margin-top: 10px;
      min-height: 15px;
    }
    .company-info {
      .decision-link-head {
        width: 180px;
        min-height: 15px;
        padding: 0;
      }
      .decision-link,
      .company-count,
      .revenue,
      .industry {
        span,
        a {
          width: 100px;
          min-height: 15px;
          margin-right: 10px;
          margin-top: 0;
        }
      }
      .revenue span {
        width: 60px;
      }
      .industry span {
        width: 160px;
      }
    }
  }
  .company-info {
    background-color: #f6f6f6;
    padding: 10px 15px;
    flex-direction: column;
    .linkedin-link-section {
      display: flex;
      justify-content: space-between;
    }
    .linkedInBtn {
      padding: 0px 12px;
      text-align: center;
      font-size: 12px;
      float: right;
      cursor: pointer;
      background-color: white;
      border: 1px solid #2176b7;
      border-radius: 15px;
      text-decoration: none;
      line-height: 20px;
      color: #2176b7;
      height: fit-content;
      svg {
        width: 12px;
        height: 12px;
        fill: #1f80ed;
      }
      span {
        margin-left: 5px;
        margin-top: 2px;
      }
    }
    .linkedInBtn:hover {
      color: $white;
      background-color: #2176b7;
      svg {
        fill: $white;
      }
    }
    .decision-link-head {
      max-width: 130px;
      font-size: 15px;
      font-weight: normal;
      text-align: left;
      color: #474542;
      @include lineClamp(2);
    }
    .multi-item {
      display: flex;
    }
    .decision-link,
    .company-count,
    .revenue,
    .industry,
    .location {
      min-width: fit-content;
      padding-right: 10px;

      margin-top: 5px;
      font-size: 14px;
      span,
      a {
        margin-left: 15px;
      }
      svg {
        width: 14px;
        height: 14px;
        fill: #575f68;
      }
    }
    .multi-item,
    .location {
      margin-top: 10px;
    }
    .location {
      svg {
        width: 42px;
      }
      span,
      a {
        margin-left: 13px;
      }
    }
  }
  .top-contact-section {
    padding: 10px 15px;
    flex-direction: column;
    padding-bottom: 0;
    box-shadow: 0 9.2px 6.2px -6.2px rgba(59, 59, 59, 0.15);
    .top-contact-head {
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.02;
      letter-spacing: normal;
      text-align: left;
      color: #a6a6a6;
      padding: 5px 0;
    }
  }
  .line-1-25 {
    line-height: 1.25;
  }
  .not-found-cinfo {
    padding: 25px 10px;
    color: $grey-color;
    text-align: center;
    p {
      margin-top: 15px;
      font-size: 15px;
    }
  }
}
</style>
